import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocationSelectorContainerComponent } from './pages/location-selector-container/location-selector-container.component';
import { CanDeactivateLocationSelector } from './services/canDeactivateLocation';

const routes: Routes = [
  {
    path: '',
    component: LocationSelectorContainerComponent,
    canDeactivate: [CanDeactivateLocationSelector],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeoLocationRoutingModule {}
